import type { RachelResource } from './uiEffect.schema';

export interface RachelScope {
  resource: RachelResource;
  scopeId: string;
}

export interface RachelScopeKeySource {
  resource: string;
  scopeId: string;
}

export const getRachelScopeKey = ({ resource, scopeId }: RachelScopeKeySource) =>
  `${resource}/${scopeId}`;
